module.exports = __webpack_public_path__ + "media/img/pages/companies/medair-d222ef68ae7d152e745b07794ad590ee.png";